import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Flex, H4, IconButton, P } from 'design-system-web';

import { FONT_AWESOME_REGULAR } from 'lane-shared/helpers/constants/icons';

import styles from './VisitorValidationConfirmationModal.scss';

type VisitorValidationConfirmationModalProps = {
  isOpen: boolean;
  turningOn: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function VisitorValidationConfirmationModal({
  isOpen,
  turningOn,
  onConfirm,
  onCancel,
}: VisitorValidationConfirmationModalProps): React.ReactElement {
  const { t } = useTranslation();

  const copyKeyPrefix = turningOn
    ? 'web.admin.visitorManagement.configuration.tab.general.visitorValidation.confirmModal.turnOn'
    : 'web.admin.visitorManagement.configuration.tab.general.visitorValidation.confirmModal.turnOff';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      size="small"
      includeHeader={false}
      disableContentPadding
      className={styles.confirmationModal}
      testId="visitorValidationConfirmationModal"
    >
      <Flex
        className={styles.confirmationModalHeader}
        justify="space-between"
        align="center"
      >
        <H4>{t(`${copyKeyPrefix}.title`)}</H4>
        <IconButton
          type={FONT_AWESOME_REGULAR}
          icon="times"
          data-test="closeButton"
          size="medium"
          onClick={onCancel}
        />
      </Flex>

      <div className={styles.confirmationModalBody}>
        <P className={styles.confirmationModalDescription}>
          {t(`${copyKeyPrefix}.body`)}
        </P>
      </div>

      <div className={styles.confirmationModalFooter}>
        <Button variant="secondary" onClick={onCancel} testId="cancelButton">
          {t(
            'web.admin.visitorManagement.configuration.tab.general.visitorValidation.confirmModal.cancelButton'
          )}
        </Button>
        <Button variant="primary" onClick={onConfirm} testId="confirmButton">
          {t(`${copyKeyPrefix}.confirmButton`)}
        </Button>
      </div>
    </Modal>
  );
}
